var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup2112(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2112",
    "data-name": "Group 2112",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 101.724,
    height: 98.048,
    viewBox: "0 0 101.724 98.048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.272,
    y1: 0.885,
    x2: 0.98,
    y2: 0.152,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff2ed",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#ffe9dd",
    stopOpacity: 0.373
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.787,
    stopColor: "#ffd5ba"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2111",
    "data-name": "Group 2111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1708",
    "data-name": "Path 1708",
    d: "M45.038,10.757C22.835,16.85,22.015,62.126,4.025,77.446c-8.85,7.537-1.034,18.213,3.753,19.729,8.921,2.826,12.058-3.141,17.83-4.9,8.432-2.551,15.021,5.807,19.659,8.478,21.2,12.208,56.418,7.367,56.458-14.731-.738-8.579-6.971-15.739-12.053-22.328-13.6-15.2-10.658-16.549-5.049-33.786,2.63-19.506-24.98-23.3-39.585-19.15Z",
    transform: "translate(-0.001 -9.25)",
    fill: "url(#linear-gradient)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Explore",
    transform: "translate(3.338 5.245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2106",
    "data-name": "Group 2106",
    transform: "translate(5.066 4.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2105",
    "data-name": "Group 2105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2083",
    "data-name": "Group 2083",
    transform: "translate(0.958 5.554)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1812",
    "data-name": "Path 1812",
    d: "M113.837,149.723,100.7,126.967a2.042,2.042,0,0,0-2.44-.907l-3.872-6.706A21.175,21.175,0,0,0,74.936,82.311V79.069a1.915,1.915,0,0,0-1.915-1.915H33.358a1.915,1.915,0,0,0-1.915,1.915v26.622H27.95a1.915,1.915,0,0,0-1.915,1.915V137a1.915,1.915,0,0,0,1.915,1.915H41.3v5.63a.958.958,0,0,0,.958.958H69.706a.958.958,0,0,0,.958-.958V125.4a.958.958,0,0,0-.958-.957H50.839V109.713H61.9a21.185,21.185,0,0,0,28.26,12.081l3.872,6.706a2.043,2.043,0,0,0-.434,2.567l13.138,22.756a2.043,2.043,0,0,0,2.791.748l3.563-2.057a2.043,2.043,0,0,0,.748-2.79Z",
    transform: "translate(-26.035 -77.154)",
    fill: "#00c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1813",
    "data-name": "Path 1813",
    d: "M282.969,388.089h3.559a.958.958,0,1,0,0-1.915h-3.559a.958.958,0,0,0,0,1.915Z",
    transform: "translate(-232.992 -326.996)",
    fill: "#00c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1814",
    "data-name": "Path 1814",
    d: "M294.188,406.555H282.969a.958.958,0,0,0,0,1.915h11.219a.958.958,0,1,0,0-1.915Z",
    transform: "translate(-232.992 -343.474)",
    fill: "#00c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1815",
    "data-name": "Path 1815",
    d: "M294.188,426.937H282.969a.958.958,0,0,0,0,1.915h11.219a.958.958,0,1,0,0-1.915Z",
    transform: "translate(-232.992 -359.953)",
    fill: "#00c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2099",
    "data-name": "Group 2099"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1816",
    "data-name": "Path 1816",
    d: "M135.127,301.057V320.2a.957.957,0,0,1-.958.957H106.726a.958.958,0,0,1-.958-.957V301.057a.958.958,0,0,1,.958-.957H134.17A.957.957,0,0,1,135.127,301.057Z",
    transform: "translate(-89.542 -251.851)",
    fill: "#9494ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1817",
    "data-name": "Path 1817",
    d: "M115.3,300.1v17.151a1.916,1.916,0,0,1-1.915,1.915h-7.62V301.057a.958.958,0,0,1,.958-.957Z",
    transform: "translate(-89.542 -251.851)",
    fill: "#8383ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2084",
    "data-name": "Group 2084",
    transform: "translate(6.365 0.958)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1818",
    "data-name": "Path 1818",
    d: "M95.851,85.713H56.188A1.915,1.915,0,0,1,54.273,83.8V55.069a1.915,1.915,0,0,1,1.915-1.915H95.851a1.915,1.915,0,0,1,1.915,1.915V83.8A1.915,1.915,0,0,1,95.851,85.713Z",
    transform: "translate(-54.273 -53.154)",
    fill: "#ff6c6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1819",
    "data-name": "Path 1819",
    d: "M0,0H24.516V35.45H0Z",
    transform: "translate(39.472 4.022) rotate(90)",
    fill: "#ffe8dc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2089",
    "data-name": "Group 2089",
    transform: "translate(35.506 4.989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2085",
    "data-name": "Group 2085",
    transform: "translate(29.163 37.453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1821",
    "data-name": "Path 1821",
    d: "M0,0H4.881V10.206H0Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 2.44)",
    fill: "#d9d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1822",
    "data-name": "Path 1822",
    d: "M365.17,273.609a21.215,21.215,0,0,1-3.838,2.83c-.042.023-.082.048-.124.071l-2.472-4.284,4.228-2.44Z",
    transform: "translate(-358.735 -269.786)",
    fill: "#b3b3ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2086",
    "data-name": "Group 2086"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_91",
    "data-name": "Ellipse 91",
    cx: 21.174,
    cy: 21.174,
    r: 21.174,
    fill: "#9494ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1823",
    "data-name": "Path 1823",
    d: "M264,126.261a17.434,17.434,0,0,1-23.338-5.6l13.373-26.883A17.434,17.434,0,0,1,264,126.261Z",
    transform: "translate(-234.106 -89.991)",
    fill: "#d9d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1824",
    "data-name": "Path 1824",
    d: "M336.477,185.867h-1.92v-1.92a.958.958,0,0,0-.958-.957h-1.937a.958.958,0,0,0-.958.957v1.92h-1.92a.958.958,0,0,0-.958.958v1.937a.958.958,0,0,0,.958.958h1.92v1.92a.958.958,0,0,0,.958.957H333.6a.958.958,0,0,0,.958-.957v-1.92h1.92a.958.958,0,0,0,.957-.958v-1.937A.957.957,0,0,0,336.477,185.867Z",
    transform: "translate(-304.583 -162.157)",
    fill: "#ff6c6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2088",
    "data-name": "Group 2088",
    transform: "translate(32.74 44.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1825",
    "data-name": "Path 1825",
    d: "M397.175,334.5l-3.563,2.057a2.043,2.043,0,0,1-2.791-.748l-13.138-22.756a2.043,2.043,0,0,1,.748-2.791l3.563-2.057a2.043,2.043,0,0,1,2.791.748l13.138,22.756A2.043,2.043,0,0,1,397.175,334.5Z",
    transform: "translate(-377.409 -307.936)",
    fill: "#ffab66"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2087",
    "data-name": "Group 2087",
    transform: "translate(7.569 13.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1826",
    "data-name": "Path 1826",
    d: "M0,0H8.2V3.554H0Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 4.1)",
    fill: "#ffd6bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1827",
    "data-name": "Path 1827",
    d: "M433.566,412.156l2.658,4.6a2.043,2.043,0,0,0,2.791.748l3.563-2.057a2.043,2.043,0,0,0,.748-2.79l-2.658-4.6Z",
    transform: "translate(-430.38 -402.54)",
    fill: "#ffd6bb"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1828",
    "data-name": "Path 1828",
    d: "M48.924,235.4H27.95a1.915,1.915,0,0,1-1.915-1.915V204.089a1.915,1.915,0,0,1,1.915-1.915H48.924a1.915,1.915,0,0,1,1.915,1.915v29.393A1.915,1.915,0,0,1,48.924,235.4Z",
    transform: "translate(-25.078 -172.678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2096",
    "data-name": "Group 2096",
    transform: "translate(6.793 35.335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2090",
    "data-name": "Group 2090",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1829",
    "data-name": "Path 1829",
    d: "M61.021,234.583H57.463a.958.958,0,1,1,0-1.915h3.559a.958.958,0,0,1,0,1.915Z",
    transform: "translate(-56.505 -232.668)",
    fill: "#ff6c6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2091",
    "data-name": "Group 2091",
    transform: "translate(0 3.903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1830",
    "data-name": "Path 1830",
    d: "M68.681,254.964H57.463a.957.957,0,1,1,0-1.915H68.681a.957.957,0,1,1,0,1.915Z",
    transform: "translate(-56.505 -253.049)",
    fill: "#ffab66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2092",
    "data-name": "Group 2092",
    transform: "translate(0 7.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1831",
    "data-name": "Path 1831",
    d: "M68.681,275.346H57.463a.958.958,0,0,1,0-1.915H68.681a.958.958,0,0,1,0,1.915Z",
    transform: "translate(-56.505 -273.431)",
    fill: "#ffab66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2094",
    "data-name": "Group 2094",
    transform: "translate(0 15.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1832",
    "data-name": "Path 1832",
    d: "M83.234,316.516H75.463a.957.957,0,1,1,0-1.915h7.772a.957.957,0,1,1,0,1.915Z",
    transform: "translate(-71.058 -314.601)",
    fill: "#ffab66"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2093",
    "data-name": "Group 2093"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_92",
    "data-name": "Ellipse 92",
    cx: 0.958,
    cy: 0.958,
    r: 0.958,
    fill: "#ff6c6c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_93",
    "data-name": "Ellipse 93",
    cx: 0.958,
    cy: 0.958,
    r: 0.958,
    transform: "translate(0 3.903)",
    fill: "#ff6c6c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2095",
    "data-name": "Group 2095",
    transform: "translate(3.447 19.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1833",
    "data-name": "Path 1833",
    d: "M83.234,336.9H75.463a.958.958,0,0,1,0-1.915h7.772a.958.958,0,0,1,0,1.915Z",
    transform: "translate(-74.505 -334.983)",
    fill: "#ffab66"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2097",
    "data-name": "Group 2097"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1834",
    "data-name": "Path 1834",
    d: "M110.624,121.2,97.486,98.442a3,3,0,0,0-2.778-1.491l-3.116-5.4A22.133,22.133,0,0,0,71.85,52.971V51.023a2.876,2.876,0,0,0-2.873-2.873H29.316a2.876,2.876,0,0,0-2.873,2.873V72.287a.958.958,0,0,0,1.915,0V51.023a.959.959,0,0,1,.958-.958H68.978a.959.959,0,0,1,.957.958v2.571A22.135,22.135,0,0,0,56.526,80.709H47.754V79.561a2.876,2.876,0,0,0-2.873-2.873H23.908a2.876,2.876,0,0,0-2.873,2.873v29.393a2.876,2.876,0,0,0,2.873,2.873H36.3V116.5a1.917,1.917,0,0,0,1.915,1.915H65.663a1.917,1.917,0,0,0,1.915-1.915V97.356a1.917,1.917,0,0,0-1.915-1.915H47.754V82.624H57.2A22.124,22.124,0,0,0,77.752,96.44a21.976,21.976,0,0,0,7.954-1.49l3.115,5.4a2.993,2.993,0,0,0-.1,3.153l1.8,3.116a.957.957,0,1,0,1.658-.958l-1.8-3.116a1.085,1.085,0,0,1,.4-1.482L94.344,99a1.087,1.087,0,0,1,1.483.4l13.138,22.756a1.085,1.085,0,0,1-.4,1.483L105,125.7a1.085,1.085,0,0,1-1.482-.4l-8.581-14.862a.957.957,0,1,0-1.658.958l8.581,14.862a2.981,2.981,0,0,0,1.822,1.4,3.015,3.015,0,0,0,.782.1,2.984,2.984,0,0,0,1.5-.4l3.563-2.057a3,3,0,0,0,1.1-4.1ZM22.95,108.953V79.561a.959.959,0,0,1,.958-.958H44.881a.959.959,0,0,1,.958.958v29.393a.959.959,0,0,1-.958.958H23.908A.959.959,0,0,1,22.95,108.953Zm42.713-11.6V116.5H38.219v-4.673h6.663a2.876,2.876,0,0,0,2.873-2.873v-11.6Zm12.086-2.831a20.21,20.21,0,1,1,10.074-2.7A20.231,20.231,0,0,1,77.749,94.525Zm11.032-1.046q.647-.374,1.258-.785l2.851,4.937-2.569,1.483-2.85-4.936Q88.133,93.853,88.781,93.479Z",
    transform: "translate(-21.035 -48.15)",
    fill: "#00c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1835",
    "data-name": "Path 1835",
    d: "M282.969,364.089h3.559a.958.958,0,1,0,0-1.915h-3.559a.958.958,0,0,0,0,1.915Z",
    transform: "translate(-232.035 -302.038)",
    fill: "#00c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1836",
    "data-name": "Path 1836",
    d: "M294.188,382.555H282.969a.958.958,0,0,0,0,1.915h11.219a.958.958,0,1,0,0-1.915Z",
    transform: "translate(-232.035 -318.516)",
    fill: "#00c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1837",
    "data-name": "Path 1837",
    d: "M294.188,402.937H282.969a.957.957,0,0,0,0,1.915h11.219a.957.957,0,1,0,0-1.915Z",
    transform: "translate(-232.035 -334.995)",
    fill: "#00c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2098",
    "data-name": "Group 2098",
    transform: "translate(39.245 8.773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1839",
    "data-name": "Path 1839",
    d: "M245.509,93.96V118.8a2.04,2.04,0,0,1-2.041,2.039H232.136c-.165-.253-.322-.511-.475-.776a17.532,17.532,0,0,1-1.544-3.51l11.105-21.739A17.336,17.336,0,0,1,245.509,93.96Z",
    transform: "translate(-229.323 -93.96)",
    fill: "#ff9494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    "data-name": "Path 1840",
    d: "M259.608,98.44v21.739h-3.3l-3.449-5.7a9.464,9.464,0,0,0,.507-12.359,17.58,17.58,0,0,1,6.243-3.677Z",
    transform: "translate(-247.709 -97.582)",
    fill: "#fff3ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    "data-name": "Path 1841",
    d: "M238.844,123.527a9.425,9.425,0,0,1-2.56,6.475l-3.3-5.452a1,1,0,0,0-.628-.463,17.371,17.371,0,0,1,4.433-6.446A9.426,9.426,0,0,1,238.844,123.527Z",
    transform: "translate(-231.134 -113.105)",
    fill: "#ffd6bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1842",
    "data-name": "Path 1842",
    d: "M234.566,162.912h-7.8a17.439,17.439,0,0,1,.429-11.616,1,1,0,0,1,.628.463Z",
    transform: "translate(-225.968 -140.316)",
    fill: "#ffab66"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1848",
    "data-name": "Path 1848",
    d: "M172.926,100.785a6.985,6.985,0,1,0-11.972,4.883,6.96,6.96,0,0,0-2,4.883,2.1,2.1,0,0,0,4.2,0,2.781,2.781,0,0,1,5.561,0,2.1,2.1,0,1,0,4.2,0,6.958,6.958,0,0,0-2-4.883,6.958,6.958,0,0,0,2-4.883ZM165.94,98a2.781,2.781,0,1,1-2.781,2.781A2.784,2.784,0,0,1,165.94,98Z",
    transform: "translate(-144.814 -85.989)",
    fill: "#ff4d4d",
    stroke: "#ffe8dc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2107",
    "data-name": "Group 2107",
    transform: "translate(28.939 55.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1829-2",
    "data-name": "Path 1829",
    d: "M61.021,234.583H57.463a.958.958,0,1,1,0-1.915h3.559a.958.958,0,0,1,0,1.915Z",
    transform: "translate(-56.505 -232.668)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2108",
    "data-name": "Group 2108",
    transform: "translate(28.939 59.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1830-2",
    "data-name": "Path 1830",
    d: "M68.681,254.964H57.463a.957.957,0,1,1,0-1.915H68.681a.957.957,0,1,1,0,1.915Z",
    transform: "translate(-56.505 -253.049)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2109",
    "data-name": "Group 2109",
    transform: "translate(28.939 63.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1831-2",
    "data-name": "Path 1831",
    d: "M68.681,275.346H57.463a.958.958,0,0,1,0-1.915H68.681a.958.958,0,0,1,0,1.915Z",
    transform: "translate(-56.505 -273.431)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2110",
    "data-name": "Group 2110",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1849",
    "data-name": "Path 1849",
    d: "M421.768,15.411a.989.989,0,0,1-.7-.291l-2.086-2.086a.993.993,0,0,1,0-1.4l2.086-2.086a.993.993,0,0,1,1.4,0l2.086,2.086a.993.993,0,0,1,0,1.4L422.47,15.12A.989.989,0,0,1,421.768,15.411Zm-.681-3.08.681.681.681-.681-.681-.681Z",
    transform: "translate(-336.955 -9.252)",
    fill: "#ff9c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1850",
    "data-name": "Path 1850",
    d: "M421.768,353.735a.989.989,0,0,1-.7-.291l-2.086-2.086a.993.993,0,0,1,0-1.4l2.086-2.086a.993.993,0,0,1,1.4,0l2.086,2.086a.993.993,0,0,1,0,1.4l-2.086,2.086A.989.989,0,0,1,421.768,353.735Zm-.681-3.079.681.681.681-.681-.681-.681Z",
    transform: "translate(-345.538 -273.229)",
    fill: "#8282ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1851",
    "data-name": "Path 1851",
    d: "M75.284,211.67a.989.989,0,0,1-.7-.291L72.5,209.293a.993.993,0,0,1,0-1.4l2.086-2.086a.993.993,0,0,1,1.4,0l2.086,2.086a.993.993,0,0,1,0,1.4l-2.086,2.086A.99.99,0,0,1,75.284,211.67Zm-.681-3.08.681.681.681-.681-.681-.681Z",
    transform: "translate(-72.204 -129.177)",
    fill: "#ff6c6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1852",
    "data-name": "Path 1852",
    d: "M403.567,418.435a.993.993,0,0,1-.7-1.7l1.987-1.987a.993.993,0,1,1,1.4,1.4l-1.987,1.987A.989.989,0,0,1,403.567,418.435Z",
    transform: "translate(-336.439 -333.955)",
    fill: "#ff9c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    "data-name": "Path 1853",
    d: "M92.7,82.694A.993.993,0,0,1,92,81l1.987-1.987a.993.993,0,0,1,1.4,1.4L93.4,82.4A.99.99,0,0,1,92.7,82.694Z",
    transform: "translate(-90.616 -72.561)",
    fill: "#8282ff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2112);
export default __webpack_public_path__ + "static/media/Group 2112.91c05d214552871c95f7c9206ee05fdb.svg";
export { ForwardRef as ReactComponent };